import React, { Component } from "react";

import {
  Table,
  Header,
  HeadCell,
  YellowCell,
  WhiteCell,
  SeashellCell,
  TableContainer,
  PageHeading,
  BoldText
} from "../shared/styledComponents";

class LeaveManagementDashboardContent extends Component {
  state = {
    isLoading: true,
    leaveManagementData: []
  };

  componentDidMount = () => {
    this.setState({
      isLoading: false,
      leaveManagementData: [
        {
          name: "Holiday days",
          totalJobs: 47,
          jobsDelivered: 34
        },
        {
          name: "Sick Leave",
          totalJobs: 12,
          jobsDelivered: 7
        }
      ]
    });
  };
  render() {
    return (
      <div>
        <PageHeading>PWG Apps Dashboard</PageHeading>
        <TableContainer>
          <BoldText>Leave Management</BoldText>
          <Table>
            <Header>
              <tr>
                <HeadCell />
                <HeadCell>Total Jobs</HeadCell>
                <HeadCell>Jobs Delivered</HeadCell>
              </tr>
            </Header>
            <tbody>
              {this.state.leaveManagementData.map((items, index) => {
                return (
                  <tr key={index} style={{ cursor: "pointer" }}>
                    <YellowCell>{items.name}</YellowCell>
                    <WhiteCell>{items.totalJobs}</WhiteCell>
                    <SeashellCell>{items.jobsDelivered}</SeashellCell>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

export default LeaveManagementDashboardContent;
